/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIEvidenceResetClearedCell } from './AIEvidenceResetClearedCell';
export type AIEvidenceResetResponse = {
  mode: AIEvidenceResetResponse.mode;
  /**
   * PDF citations retired by this call, whatever their review state.
   */
  citations_cleared: number;
  /**
   * Excel references retired by this call. Clear Pending counts only the pending AI ones; the other modes count every reference in scope.
   */
  excel_references_removed: number;
  /**
   * AI suggestion entries removed by this call (one per cell).
   */
  findings_dismissed: number;
  /**
   * Ids of the PDF citations retired by this call, ascending.
   */
  retired_citation_ids: Array<number>;
  /**
   * Ids of the Excel references retired by this call, ascending.
   */
  retired_mapping_ids: Array<number>;
  /**
   * The cell of each AI suggestion entry removed by this call.
   */
  cleared_cells: Array<AIEvidenceResetClearedCell>;
};
export namespace AIEvidenceResetResponse {
  export enum mode {
    START_FRESH = 'start_fresh',
    CLEAR_AI_EVIDENCE = 'clear_ai_evidence',
    CLEAR_AI_SUGGESTIONS = 'clear_ai_suggestions',
    CLEAR_CELLS = 'clear_cells',
    CLEAR_MAPPINGS = 'clear_mappings',
  }
}

